import { useState, useCallback } from "react";
import getOrderDetails from "../helpers/getOrderDetails";
import getAccessToken from "../helpers/getAccessToken";
import trackMyOrder from "../helpers/trackMyOrder";

export const useOrderInvoiceDetails = () => {
  const [fetchingOrderInvoiceDetails, setFetchingOrderInvoiceDetails] = useState(false);

  const getOrderInvoiceDetails = useCallback((orderId) => {
    setFetchingOrderInvoiceDetails(true);

    return getAccessToken()
      .then((accessToken) => {
        return getOrderDetails(accessToken, orderId, true, false);
      })
      .then(({ data }) => {
        setFetchingOrderInvoiceDetails(false);
        return (data && data.data && data.data.order) || [];
      })
      .catch((err) => {
        setFetchingOrderInvoiceDetails(false);
        throw err;
      });
  }, []);

  const getGuestOrderInvoiceDetails = useCallback((email, orderId) => {
    setFetchingOrderInvoiceDetails(true);

    return trackMyOrder(email, orderId, true, false)
      .then(({ data }) => {
        setFetchingOrderInvoiceDetails(false);
        return (data && data.data && data.data.orderDetails) || [];
      })
      .catch((err) => {
        setFetchingOrderInvoiceDetails(false);
        throw err;
      });
  }, []);

  return { getOrderInvoiceDetails, getGuestOrderInvoiceDetails, fetchingOrderInvoiceDetails };
};
